<!-- Tooltip.svelte -->
<script lang="ts">
    import CN from "classnames";

    import Icon from "@components/Icon.svelte";

    import ReviewTooltipArrowIcon from "../icons/ReviewTooltipArrowIcon.svelte";

    export let isOpen = false;

    let isHovered = false;

    function mouseOver(event: MouseEvent) {
        isHovered = true;
    }

    function mouseLeave(event: MouseEvent) {
        isHovered = false;
    }
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<div class="gw-rv-tooltip" on:mouseover={mouseOver} on:mouseleave={mouseLeave}>
    <slot name="targetElement" />

    <div
        class={CN("gw-rv-tooltip__tooltip", {
            "gw-rv-tooltip__tooltip--show": isHovered || isOpen,
        })}
    >
        <div class="gw-rv-tooltip-arrow">
            <Icon width="56" height="15" viewBox="0 0 56 15">
                <ReviewTooltipArrowIcon />
            </Icon>
        </div>
        <slot name="content" />
    </div>
</div>

<style lang="postcss">
    .gw-rv-tooltip {
        display: flex;
        justify-content: center;
        position: relative;

        &__tooltip {
            display: none;
            flex-direction: column;
            justify-content: center;
            width: auto;
            background: #fff;
            box-shadow: 0px 0px 16.6px 4px rgba(0, 0, 0, 0.1);
            position: absolute;
            top: 2.2em;
            left: 0;

            z-index: var(--gw-z-index-tooltip);

            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                width: 100%;
                height: calc(100% + 2.2em);
                z-index: -1;
            }
        }

        &__tooltip--show {
            display: flex;
        }
    }

    .gw-rv-tooltip-arrow {
        display: flex;
        justify-content: center;
        width: auto;
        border-style: solid;
        z-index: 110;
        position: absolute;
        border: none;

        top: -5%;
        margin-left: auto;
        margin-right: auto;
        left: 1.25em;
    }
</style>
